// HubSpot validates a field as soon as it loses focus, so an empty required field
// turns red just for being tabbed through. Here an empty field is only flagged after
// a submit attempt on its step; a wrong value (a bad phone number, say) shows at once.
const RENDERER = '[data-hsfc-id="Renderer"]';
const FIELDS = '.hsfc-TextField, .hsfc-EmailField, .hsfc-NumberField, .hsfc-PhoneField, .hsfc-DropdownField, .hsfc-TextareaField';
const TRIED = 'data-armada-tried';

function isEmpty(field: HTMLElement): boolean {
	const input = field.querySelector<HTMLInputElement | HTMLTextAreaElement>('input:not([type="hidden"]):not([role="searchbox"]), textarea');
	const value = (input?.value || '').trim();

	// The phone number starts filled with the country code, e.g. "+380".
	if (field.classList.contains('hsfc-PhoneField')) {
		return /^\+?\d{0,4}$/.test(value.replace(/[\s()-]/g, ''));
	}

	return '' === value;
}

function refresh(): void {
	document.querySelectorAll<HTMLElement>(`${RENDERER} :is(${FIELDS})`).forEach((field) => {
		const invalid = !!field.querySelector('[aria-invalid="true"]');
		const tried = !!field.closest(`[${TRIED}]`);

		field.classList.toggle('armada-is-error', invalid && (tried || !isEmpty(field)));

		// Flags HubSpot's standard empty-field message; CSS shortens it to "Required".
		const alert = field.querySelector(':scope > .hsfc-ErrorAlert');

		if (alert) {
			alert.toggleAttribute('data-armada-required', /complete this required field/i.test(alert.textContent || ''));
		}
	});
}

let queued = 0;

function schedule(): void {
	if (!queued) {
		queued = window.setTimeout(() => {
			queued = 0;
			refresh();
		}, 0);
	}
}

// A submit or "Next" attempt marks its step, so its empty required fields may show.
function markTried(target: Element): void {
	const step = target.closest('.hsfc-Step') || target.closest(RENDERER);

	if (step) {
		step.setAttribute(TRIED, '');
		schedule();
	}
}

export default function initHubspotFields(): void {
	document.addEventListener(
		'click',
		(event) => {
			const button = (event.target as Element).closest(`${RENDERER} .hsfc-Button`);

			if (button) {
				markTried(button);
			}
		},
		true
	);

	document.addEventListener(
		'submit',
		(event) => {
			const form = event.target as Element;

			if (form.closest(RENDERER)) {
				markTried(form);
			}
		},
		true
	);

	document.addEventListener('input', schedule, true);

	// HubSpot renders the forms late and flips aria-invalid on its own.
	new MutationObserver(schedule).observe(document.body, {
		subtree: true,
		childList: true,
		attributes: true,
		attributeFilter: ['aria-invalid'],
	});
}
